import React, { useEffect, useState } from "react";
import TmsTabsLayout from "../../../../components/tms-customs/tms-tabs-layout";
import tmsRouteMap from "../../../../constants/tms-route.map";
import { withRouter } from "../../../../utils/tms-with-router/tms-with-router";
import TmsCmsSlots from "../../../common-manage-slots/tms-cms-slots";
import TmsTollgateInnerPagesAll from "./tms-sm-tollgate-inner-pages/tms-tollgate-inner-pages-all";
import TmsTollgateInnerPagesAnd from "./tms-sm-tollgate-inner-pages/tms-tollgate-inner-pages-and";
// import TmsTollgateInnerPagesDbd from "./tms-sm-tollgate-inner-pages/tms-tollgate-inner-pages-tbd";

const TmsSmTollgate = ({ router }) => {
  const [active, setActive] = useState("all");

  useEffect(() => {
    let location = router.location?.pathname;
    if (location === tmsRouteMap.serviceManagement_tollgate) {
      setActive("all");
      return;
    } else if (location.includes(tmsRouteMap.sm_tollgate_add_new_tollgate)) {
      setActive("Add New Tollgate");
    }
    // else if (location.includes(tmsRouteMap.sm_tollgate_booking_details)) {
    //   setActive("Tollgate Booking Details");
    // }
    else if (location.includes(tmsRouteMap.sm_tollgate_manage_counter)) {
      setActive("all");
      return;
    }
  }, [router.location?.pathname]);
  const location = router.location?.pathname;
  const components = [
    {
      name: "All",
      Element: location.includes(tmsRouteMap.sm_tollgate_manage_counter) ? (
        <TmsCmsSlots type="tollgate-counters" />
      ) : (
        <TmsTollgateInnerPagesAll />
      ),
      key: "all",
      route: tmsRouteMap.serviceManagement_tollgate,
    },

    {
      name: "Add New Tollgate",
      Element: <TmsTollgateInnerPagesAnd />,
      key: "Add New Tollgate",
      route: tmsRouteMap.sm_tollgate_add_new_tollgate,
    },
    // {
    //   name: "Tollgate Booking Details",
    //   Element: <TmsTollgateInnerPagesDbd />,
    //   key: "Tollgate Booking Details",
    //   route: tmsRouteMap.sm_tollgate_booking_details,
    // },
  ];

  return (
    <div style={{ width: "100%", height: "100%" }}>
      <TmsTabsLayout
        components={components}
        active={active}
        setActive={setActive}
      />
    </div>
  );
};
export default withRouter(TmsSmTollgate);
